/**
 * Row/section click rules for the scaling tab. Clicking a row or section picks
 * up the seats that have no price level yet, so scaling the rest of a row does
 * not drag the already scaled seats along with it. When every seat in the
 * row/section is assigned, the whole group is selectable again — that is how a
 * full row/section is moved from one price level to another.
 */

import { sectionHasAssignedGaSeats } from './gaSeatInventory'

export const preferUnassignedSeatIds = (
  seatIds = [],
  isAssignedToPriceLevel = () => false
) => {
  const unassignedIds = seatIds.filter(
    (seatId) => !isAssignedToPriceLevel(seatId)
  )

  return unassignedIds.length > 0 ? unassignedIds : seatIds
}

// GA sections hold spots instead of seats, but follow the same rule: only fall
// back to the price level's spots when the section has no unassigned spots.
export const getGaSectionSourceId = (
  sectionId,
  assignedPriceLevelId,
  unassignedGaSeats
) =>
  !assignedPriceLevelId ||
  sectionHasAssignedGaSeats(unassignedGaSeats, sectionId)
    ? 'unassigned'
    : assignedPriceLevelId
